const web = require('./web');

module.exports = {web};
